import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('empty-list')
export class EmptyList extends LitElement {
  render() {
    return html`<p>No files found</p>`;
  }
}
